import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
function useApp() {
  const {
    stages: { reset, setCurrent }
  } = useAppActions();
  return {
    actions: {
      reset,
      setCurrentStage: setCurrent
    }
  };
}
export {
  useApp
};
